export const INFRASTRUCTURE_RADIUS = 1000;
